(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.buildStarfield();

      this.slides = Array.from(this.querySelectorAll('.ann-bar__slide'));
      if (this.slides.length <= 1) return;

      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.prevBtn = this.querySelector('.ann-bar__btn--prev');
      this.nextBtn = this.querySelector('.ann-bar__btn--next');
      this.interval = Math.max(2, parseFloat(this.dataset.interval) || 5) * 1000;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._prev = () => this.go(-1, true);
      this._next = () => this.go(1, true);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._prev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._next);

      this._stop = this.stop.bind(this);
      this._start = this.start.bind(this);
      this.addEventListener('mouseenter', this._stop);
      this.addEventListener('mouseleave', this._start);
      this.addEventListener('focusin', this._stop);
      this.addEventListener('focusout', this._start);

      this.start();
    }

    buildStarfield() {
      var box = this.querySelector('.ann-bar__stars');
      if (!box || box.dataset.built) return;
      box.dataset.built = '1';

      var count = parseInt(this.dataset.starCount, 10) || 50;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var frag = document.createDocumentFragment();

      for (var i = 0; i < count; i++) {
        var star = document.createElement('span');
        var size = (1 + Math.random() * 1.6).toFixed(2);
        star.style.left = (Math.random() * 100).toFixed(2) + '%';
        star.style.top = (Math.random() * 100).toFixed(2) + '%';
        star.style.width = size + 'px';
        star.style.height = size + 'px';

        if (reduce) {
          star.style.opacity = (0.5 + Math.random() * 0.45).toFixed(2);
        } else {
          star.className = 'tw';
          star.style.setProperty('--d', (2 + Math.random() * 3).toFixed(2) + 's');
          star.style.setProperty('--dl', (Math.random() * 4).toFixed(2) + 's');
        }

        frag.appendChild(star);
      }

      box.appendChild(frag);
    }

    disconnectedCallback() {
      this.stop();
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._prev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._next);
    }

    go(direction, userInitiated) {
      const n = this.slides.length;
      const to = (this.index + direction + n) % n;
      if (to === this.index) return;

      const dir = direction > 0 ? 'next' : 'prev';
      const current = this.slides[this.index];
      const incoming = this.slides[to];

      // Clear any leftover transient state on the slides not involved.
      this.slides.forEach((s) => {
        if (s !== current && s !== incoming) {
          s.classList.remove('is-active', 'exit-next', 'exit-prev', 'enter-next-start', 'enter-prev-start');
        }
      });

      // Place incoming on its entry side with no transition, then slide it in.
      incoming.classList.remove('is-active', 'exit-next', 'exit-prev');
      incoming.classList.add(dir === 'next' ? 'enter-next-start' : 'enter-prev-start');
      void incoming.offsetWidth; // commit the start position
      incoming.classList.remove('enter-next-start', 'enter-prev-start');
      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      if (incoming.tagName === 'A') {
        incoming.removeAttribute('tabindex');
      } else {
        incoming.setAttribute('tabindex', '-1');
      }

      // Slide outgoing out to the opposite side.
      current.classList.remove('is-active', 'enter-next-start', 'enter-prev-start');
      current.classList.add(dir === 'next' ? 'exit-next' : 'exit-prev');
      current.setAttribute('aria-hidden', 'true');
      current.setAttribute('tabindex', '-1');

      const cleanup = (event) => {
        if (event && event.target !== current) return;
        current.classList.remove('exit-next', 'exit-prev');
        current.removeEventListener('transitionend', cleanup);
      };
      current.addEventListener('transitionend', cleanup);

      this.index = to;
      if (userInitiated) this.restart();
    }

    start() {
      if (!this.autoplay || this.reduce || this.slides.length <= 1 || this.timer) return;
      this.timer = setInterval(() => this.go(1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildIframe(btn) {
    var id = btn.getAttribute('data-yt-id');
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.className = 'fv-iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = btn.getAttribute('data-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    iframe.setAttribute('frameborder', '0');
    btn.replaceWith(iframe);
  }
  function init(scope) {
    (scope || document).querySelectorAll('.fv-facade:not([data-bound])').forEach(function (btn) {
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () { buildIframe(btn); }, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); }); // theme editor
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
